import React, { useEffect, useState, useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';

let lastPositionX = 0;
let lastPositionY = 0;

const Artboards:React.FC<IProps> = (props) => {

  const canvas = useRef<HTMLCanvasElement>(null);
  const [clicked, setClicked] = useState("none");
  const [artboardClicked, setArtboardClicked] = useState(false);

  useEffect(() => {
    if (canvas.current && props.child.artboard?.rect) {
      canvas.current.width = props.dimensions.width;
      canvas.current.height = props.dimensions.height;
      var ctx = canvas.current.getContext('2d');
      if (ctx) {
        const artboard = props.child.artboard;
        ctx.fillStyle = `rgba(${artboard.color.r}, ${artboard.color.g}, ${artboard.color.b}, ${1})`;
        const canvasWidth = artboard.rect.right  - artboard.rect.left;
        const canvasHeight = artboard.rect.bottom - artboard.rect.top;
        ctx.fillRect(artboard.rect.left, artboard.rect.top, canvasWidth, canvasHeight);
      }
    }
  }, [])

  useEffect(() => {
    if (clicked !== "none") {
      handleMove(props.coors);
    } 
  }, [props.coors])

  const handleMove = (coors: any) => {
  }

  const setInitMoveMargins = (e: any, side: string) => {
    setClicked(side);
    lastPositionX = e.clientX;
    lastPositionY = e.clientY;
  }

  return (
    <S.Root>
      <S.TitleContainer
        style={{
          left: props.child?.artboard?.rect.left + 100 - 1,
          top: props.child?.artboard?.rect.top + 100 - 25,
          color: props.previewOnly === true ? `#000000CC` : `white`,
        }}
        onClick={() => setArtboardClicked(!artboardClicked)}
      >
        {props.child?.name}
      </S.TitleContainer>
      <S.Box
        style={{
          left: props.child?.artboard?.rect.left + 100 - 1,
          top: props.child?.artboard?.rect.top + 100 - 1,
          width: props.child?.artboard?.rect.right - props.child?.artboard?.rect.left, 
          height: props.child?.artboard?.rect.bottom - props.child?.artboard?.rect.top,
        }}
      >
        <S.ArtboardContainer
          style={{
            left: -(props.child?.artboard?.rect.left + 100 - 1),
            top: -(props.child?.artboard?.rect.top + 100 - 1),
          }}
        >
          <S.BackgroundContainer
            style={{
              width: `${props.dimensions.width}px`,
              height: `${props.dimensions.height}px`
            }}
          >
            <S.BackgroundCanvas
              id={`canvas-background-${props.index}`} 
              ref={canvas}
            />
          </S.BackgroundContainer>
          {props.children}
        </S.ArtboardContainer>
        {
          artboardClicked === true &&
          <S.BoxContainer>
            <S.MoveBox
              style={{
                cursor: clicked ? 'move' : 'auto',
              }}
            />
            <S.LeftSide >
              <S.VerticalBarContainer
                onMouseDown={(e) => setInitMoveMargins(e, "left")}
              >
                <S.VerticalBar />
              </S.VerticalBarContainer>
            </S.LeftSide>
            <S.RightSide >
              <S.VerticalBarContainer
                onMouseDown={(e) => setInitMoveMargins(e, "right")}
              >
                <S.VerticalBar />
              </S.VerticalBarContainer>
            </S.RightSide>
            <S.TopSide >
              <S.HorizontalBarContainer
                onMouseDown={(e) => setInitMoveMargins(e, "top")}
              >
                <S.HorizontalBar />
              </S.HorizontalBarContainer>
            </S.TopSide>
            <S.BottomSide >
              <S.HorizontalBarContainer
                onMouseDown={(e) => setInitMoveMargins(e, "bottom")}
              >
                <S.HorizontalBar />
              </S.HorizontalBarContainer>
            </S.BottomSide>
          </S.BoxContainer>
        }
      </S.Box>
    </S.Root>
  );
}

export default Artboards;